import { Box, Button, Checkbox, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  AddButton,
  SubmitButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { Icon } from "@iconify/react";
import { useSnackbar } from "notistack";

const CycletAssessTypes = ({ setSelectedSections }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  // ✅ State to store selected item IDs
  const [selectedIds, setSelectedIds] = useState([]);

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  const handleSetSections = () => {
    if (selectedIds.length === 0) {
      return enqueueSnackbar("Please select a section", { variant: "error" });
    }

    setSelectedSections([...selectedIds]);
    setOpen(false);
    enqueueSnackbar("Form created successfully", { variant: "success" });
  };

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={"Select Methods"}
      closeButton={true}
      fullWidth
      maxWidth={"md"}
      popupButton={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <AddButton size={"small"} action={() => setOpen(true)}>
            Add sections
          </AddButton>
        </Box>
      }
      content={
        <>
          {appraisalStages.map((item, i) => (
            <Box key={item.id}>
              <Paper
                elevation={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1,
                  mt: 1,
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#e5ebf6",
                        height: 50,
                        width: 50,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Box>
                      <Typography variant="subtitle1">{item.title}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ ml: 8 }}>
                    <Typography sx={{ fontSize: 12, color: "grey.500" }}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>

                {/* ✅ Controlled Checkbox */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    checked={selectedIds.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                </Box>
              </Paper>
            </Box>
          ))}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <SubmitButton size={"small"} action={handleSetSections}>
              Submit
            </SubmitButton>
          </Box>
        </>
      }
    />
  );
};

export default CycletAssessTypes;
const appraisalStages = [
  {
    id: 1,
    title: "Self Appraisal",
    description: "An employee's analysis of their own performance",
    status: "completed",
    icon: (
      <Icon
        style={{ marginRight: "5px", color: "#3173b4" }}
        icon="mdi:person-star-outline"
        width="24"
        height="24"
      />
    ),
    active: false,
  },
  {
    id: 2,
    title: "Manager Review",
    description:
      "The final stage of feedback given by the reviewers chosen for this cycle",
    status: "active",
    icon: (
      <Icon
        icon="hugeicons:manager"
        width="24"
        height="24"
        style={{ color: "#3173b4" }}
      />
    ),
    active: true,
  },
];
